import dayjs from 'dayjs';

export const formatDateTimeDayJs = (date: Date): string => {
  return dayjs(date).format('DD/MM/YYYY - HH:mm');
};
